import React from 'react';
import styles from './InputRow.module.scss';

export default function InputRow({noPadding=false, children }) {
  return noPadding ===false ? (<div className={styles.inputRow}>{children}</div>) : (<div className={styles.inputRowNoPadding}>{children}</div>);
}
